import type { OnboardingPayload } from '../types/onboardingIntake';

export function normalizeUrlInput(value: string): string {
  const trimmed = value.trim();
  if (!trimmed) return '';
  if (/^[a-z][a-z0-9+.-]*:/i.test(trimmed)) return trimmed;
  return `https://${trimmed}`;
}

export function isPlausibleUrl(value: string): boolean {
  const trimmed = value.trim();
  if (!trimmed) return false;
  if (/^[a-z][a-z0-9+.-]*:\/\/.+/i.test(trimmed)) return true;
  return /^([\w-]+\.)+[a-z]{2,}(\/.*)?$/i.test(trimmed);
}

const normalizeOptionalUrl = (value: unknown) =>
  typeof value === 'string' ? normalizeUrlInput(value) : value;

export function normalizeOnboardingPayloadUrls(
  payload: OnboardingPayload,
): OnboardingPayload {
  return {
    ...payload,
    business: {
      ...payload.business,
      website: normalizeOptionalUrl(payload.business.website) as string,
    },
    ordering: {
      ...payload.ordering,
      menu_link: normalizeOptionalUrl(payload.ordering.menu_link) as
        | string
        | undefined,
      menu_url: normalizeOptionalUrl(payload.ordering.menu_url) as
        | string
        | undefined,
      ordering_link: normalizeOptionalUrl(payload.ordering.ordering_link) as
        | string
        | undefined,
      ordering_url: normalizeOptionalUrl(payload.ordering.ordering_url) as
        | string
        | undefined,
    },
    reservations: {
      ...payload.reservations,
      reservation_link: normalizeOptionalUrl(
        payload.reservations.reservation_link,
      ) as string | undefined,
    },
    events: {
      ...payload.events,
      event_link: normalizeOptionalUrl(payload.events.event_link) as
        | string
        | undefined,
    },
    catering: {
      ...payload.catering,
      catering_link: normalizeOptionalUrl(payload.catering.catering_link) as
        | string
        | undefined,
    },
    gift_cards: {
      ...payload.gift_cards,
      gift_card_link: normalizeOptionalUrl(
        payload.gift_cards.gift_card_link,
      ) as string | undefined,
    },
    knowledge_base: {
      ...payload.knowledge_base,
      faq_url: normalizeOptionalUrl(payload.knowledge_base.faq_url) as string,
    },
  };
}
